import { Page, Text, View, Document, StyleSheet ,Font ,Image} from '@react-pdf/renderer';
import React from 'react'
import LatoRegular from '../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
Font.register({
    family: 'Lato',
    fonts: [
      { src: LatoRegular, fontWeight: 400 },
      { src: LatoBold , fontWeight: 700 }
    ]
  });

const styles = StyleSheet.create({
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: "#5795B2",
        borderBottom: "1px solid #5795B2",
        marginBottom: "16px"
    },
    title: {
        width: "183px",
        fontSize: "14px",
        fontFamily: "Lato",
        lineHeight: "18px",
        color: "#5795B2",
        fontWeight: 400,

    },
    titlebold: {
        fontWeight: 700
    },
    details: {
        fontSize: "10px",
        fontFamily: "Lato",
        lineHeight: "16px",
        color: "#5795B2",
        fontWeight: 400,
        width: "73px",
        textAlign: "right"

    },
    textbold: {
        fontWeight: 700
    },

});

const PDFHeader = () => (
    <View style={styles.header}>
                    <View style={styles.title}>
                        <Text style={styles.titlebold}>Quadrant Flow</Text>
                        <Text>Life & Leadership Assessment</Text>
                    </View>
                    <View style={styles.details}>
                        <Text style={styles.textbold}>Rob Murray</Text>
                        <Text>Atlas Real Estate</Text>
                        <Text>Oct 18, 2024</Text>
                    </View>
                </View>
);

export default PDFHeader;
